import { Outlet } from 'react-router-dom'
import { Sidebar } from './Sidebar'
import { TopBar } from './TopBar'
import { CommandPalette } from '@/components/command/CommandPalette'
import { TeamChatWidget } from '@/components/team/TeamChatWidget'
import { ConfirmHost } from '@/lib/confirm'
import { useInboxAlerts } from '@/hooks/useInboxAlerts'

export function DashboardLayout() {
  // Poll the inbox for new threads/messages, play sound + push to
  // notification centre. Mounted here so alerts fire from any page.
  useInboxAlerts()
  return (
    <div className="flex min-h-screen bg-canvas text-ink-900">
      <Sidebar />
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar />
        <main className="flex-1 overflow-y-auto clean-scroll">
          <Outlet />
        </main>
      </div>
      <CommandPalette />
      <TeamChatWidget />
      <ConfirmHost />
    </div>
  )
}
